import { Box, Grid2 as Grid, TextField, Typography } from '@mui/material';
import { VersionTooltip } from '@/components/VersionTooltip';
import type { FieldVersionHistory } from '@/hooks/useVersionHistory';
import { PRODUCTION_FIELDS } from '../constants';
import { styles } from '../styles';
import type { DealDetailsFormField, DealDetailsFormValue, DealDetailsFormValues } from '../types';
import { getSectionMetadata } from '../utils/getSectionMetadata';
import { FormSection } from './FormSection';

type ProductionSectionProps = {
  values: DealDetailsFormValues;
  onChange: (field: DealDetailsFormField, value: DealDetailsFormValue) => void;
  errors?: Record<string, boolean>;
  versionHistory?: Map<string, FieldVersionHistory>;
};

export const ProductionSection = ({
  values,
  onChange,
  errors = {},
  versionHistory,
}: ProductionSectionProps) => {
  const metadata = getSectionMetadata(versionHistory, PRODUCTION_FIELDS);

  return (
    <FormSection title='Production' metadata={metadata}>
      <Grid size={12} spacing={2} container>
        {PRODUCTION_FIELDS.map(field => (
          <Grid size={{ sm: 12, md: 4 }} key={field.key}>
            <VersionTooltip fieldHistory={versionHistory?.get(field.key)} fieldType={field.type}>
              <Box>
                <Box sx={{ mb: 1 }}>
                  <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                    {field.label}
                  </Typography>
                </Box>
              </Box>
            </VersionTooltip>
            <TextField
              sx={styles.textField}
              name={field.key}
              value={values[field.key] || ''}
              onChange={event => onChange(field, event.target.value)}
              error={errors[field.key] || false}
              helperText={errors[field.key] ? 'Must be a number' : ''}
              fullWidth
              slotProps={{
                input: {
                  endAdornment: (
                    <Box sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>{field.unit}</Box>
                  ),
                },
              }}
            />
          </Grid>
        ))}
      </Grid>
    </FormSection>
  );
};
